import styled from "@emotion/styled";
import { memo } from "react";
import { dataViz } from "@atlas-int/tokens";
import type { ScaleLinear } from "d3-scale";
import { GridRows } from "@visx/grid";

const ChartGridlinesElement = styled.g`
  pointer-events: none;
`;

interface YAxisGridlinesProps {
  scale: ScaleLinear<number, number>;
  containerSize: { width: number; height: number };
  chartMargin: { left: number; right: number; top: number; bottom: number };
}

const YAxisGridlines = ({ scale, containerSize, chartMargin }: YAxisGridlinesProps) => {
  return (
    <ChartGridlinesElement transform={`translate(${chartMargin.left}, 0)`}>
      <GridRows
        scale={scale}
        width={containerSize.width - chartMargin.left - chartMargin.right}
        numTicks={10}
        stroke={dataViz.gridline}
        strokeWidth={1}
      />
    </ChartGridlinesElement>
  );
};

export default memo(YAxisGridlines);
